module.exports = __webpack_public_path__ + "static/media/40_ThorstenTeriete_webfinal.5aa9a217.jpg";